// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__JXb5r","content":"ManualTimeModal_content__3CeL2"};